import { createContext, useState, ReactNode } from 'react';
import { Calculation, FullProduct } from 'types/domainTypes';

interface CalculationContextType {
  calculation: Calculation | undefined;
  setCalculation: (calculationDetails: any) => void;
  shouldShowFastenersTooltip: boolean;
  setShouldShowFastenersTooltip: (shouldShowFastenersTooltip: boolean) => void;
  product: FullProduct | undefined;
}

const DefaultCalculationContext = {
  calculation: undefined,
  setCalculation: () => {},
  shouldShowFastenersTooltip: false,
  setShouldShowFastenersTooltip: () => {},
  product: undefined,
};

export const CalculationContext = createContext<CalculationContextType>(DefaultCalculationContext);

export const CalculationContextProvider = ({ children }: { children: ReactNode | ReactNode[] }) => {
  const [calculation, setCalculation] = useState<Calculation | undefined>();
  const [shouldShowFastenersTooltip, setShouldShowFastenersTooltip] = useState<boolean>(false);

  const value = {
    ...DefaultCalculationContext,
    calculation,
    setCalculation,
    shouldShowFastenersTooltip,
    setShouldShowFastenersTooltip,
    product: calculation?.product,
  };

  return <CalculationContext.Provider value={value}>{children}</CalculationContext.Provider>;
};
